import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { MetricsDisplayGridRowDataFragmentGql } from './MetricsDisplayGridRowDataFragmentGql';

export const DatabaseDownstreamMetricsQueryGql: DocumentNode = gql`
query DatabaseDownstreamMetricsQuery($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  databases(filter: { id: $databaseId }) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowDataFragment
      }
    }
  }
}
${MetricsDisplayGridRowDataFragmentGql}
`;
